import { OfferType } from '@smg-real-estate/hg-rets-schema';
import { AgencyBasePackage } from '@smg-real-estate/hg-search-libs';

export enum AgencyCardOutcome {
  AgencyCardWithPhoneWithoutBadge = 'O1',
  AgencyCardWithoutPhoneWithBadge = 'O2',
  BrandedListingBoxWithBadge = 'O3',
  // Unused after KK-3468: eligible Rent now returns O3. Kept so outcome ids stay stable.
  BrandedListingBoxWithoutBadge = 'O4',
  NothingSpecial = 'O5',
}

const PREMIUM_PACKAGES = new Set<AgencyBasePackage>([
  AgencyBasePackage.RE_GOLD,
  AgencyBasePackage.RE_SILVER,
  AgencyBasePackage.RE_WELCOME,
]);

export interface AgencyCardOutcomeInput {
  isPremiumBranding: boolean;
  hasAgencyAgent: boolean;
  basePackage: AgencyBasePackage | null | undefined;
  offerType: OfferType | undefined;
}

export function getAgencyCardOutcome({
  isPremiumBranding,
  hasAgencyAgent,
  basePackage,
  offerType,
}: AgencyCardOutcomeInput): AgencyCardOutcome {
  if (isPremiumBranding && hasAgencyAgent) {
    return AgencyCardOutcome.AgencyCardWithPhoneWithoutBadge;
  }

  const normalizedPackage = basePackage?.trim() as AgencyBasePackage | undefined;
  if (!normalizedPackage || !PREMIUM_PACKAGES.has(normalizedPackage)) {
    return AgencyCardOutcome.NothingSpecial;
  }

  if (offerType === OfferType.Rent) {
    return AgencyCardOutcome.BrandedListingBoxWithBadge;
  }

  if (offerType !== OfferType.Buy) {
    return AgencyCardOutcome.NothingSpecial;
  }

  return hasAgencyAgent
    ? AgencyCardOutcome.AgencyCardWithoutPhoneWithBadge
    : AgencyCardOutcome.BrandedListingBoxWithBadge;
}
